import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { arrayByLength } from "../../../../../shared";
import { SLIDE_NUMBER } from "../constants";
import { getCurrentYear } from './getCurrentYear';

const [MIN_YEAR, YEAR_STEP, COUNT_FORECAST_YEARS] = [120070101, 10000, 3];

export async function getDefaultMark(dictionariesService: DictionariesService) {
  const lastYearCalendar = await dictionariesService.getDictionary({
    id: 'slides-f-last-calendar',
    parameters: {
      attributes: '',
      units: '',
      commodities: '103',
      countries: '',
      slide: SLIDE_NUMBER,
    },
  });

  const lastYearCalendarItems = await lastYearCalendar.getAll();

  const currentYear = getCurrentYear();
  const limitYear = Number(lastYearCalendarItems[0]?.id || (currentYear + (COUNT_FORECAST_YEARS * YEAR_STEP)));

  const countLastYears = (limitYear - MIN_YEAR) / YEAR_STEP + 1;
  const yearsIds = arrayByLength(countLastYears).map((_, i) => MIN_YEAR + (i * YEAR_STEP));

  return {
    calendar: yearsIds,
    limitDate: limitYear,
  };
}